import Currency from '../../../utils/currency';

export default {
    nav: {
        daily: "Diario",
        weekly: "Semanal"
    },
    daily: {
        title: "Bono diario",
        online: "45 min en línea",
        fishing: "apuestas de pesca",
        slots: "apuestas de tragamonedas"
    },
    weekly: {
        title: "Bono semanal",
        online: "250 min en línea",
        fishing: "apuestas de pesca",
        slots: "apuestas de tragamonedas"
    },
    progress: "Progreso",
    get: ({amount, currency}) => `GET ${Currency(amount, currency)}`,
    claimed: `CLAIMED`,
    claim: ({amount}) => `GET $${amount}`,
    amount: ({amount}) => `$${amount}`,
    users: ({count}) => `${count}`
}